var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 18.8366C9.59622 18.8366 6.83719 16.0776 6.83719 12.6742C6.83719 9.27075 9.59622 6.51172 12.9996 6.51172C16.4031 6.51172 19.1621 9.27075 19.1621 12.6742C19.1621 16.0776 16.4031 18.8366 12.9996 18.8366Z",
    stroke: "#CAC2C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0009 16.5685C10.8516 16.5685 9.10919 14.8262 9.10919 12.6768C9.10919 10.5275 10.8516 8.78516 13.0009 8.78516C15.1502 8.78516 16.8926 10.5275 16.8926 12.6768C16.8926 14.8262 15.1502 16.5685 13.0009 16.5685Z",
    stroke: "#CAC2C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23077 3.91877H7.43508L8.56923 1.36492C8.61766 1.25623 8.69657 1.1639 8.7964 1.09914C8.89623 1.03437 9.01269 0.999932 9.13169 1H16.8671C16.9861 0.999985 17.1027 1.03451 17.2025 1.09939C17.3023 1.16428 17.3812 1.25673 17.4295 1.36554L18.5643 3.91877H23.7692C24.0957 3.91877 24.4087 4.04844 24.6395 4.27925C24.8703 4.51007 25 4.82312 25 5.14954V20.2018C25 20.5283 24.8703 20.8413 24.6395 21.0721C24.4087 21.3029 24.0957 21.4326 23.7692 21.4326H2.23077C1.90435 21.4326 1.5913 21.3029 1.36048 21.0721C1.12967 20.8413 0.999999 20.5283 0.999999 20.2018V5.14954C0.999999 4.82312 1.12967 4.51007 1.36048 4.27925C1.5913 4.04844 1.90435 3.91877 2.23077 3.91877V3.91877Z",
    stroke: "#CAC2C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c41750e0395f0f6e26bfecf49bd47a11.svg";
export { ForwardRef as ReactComponent };